export default __webpack_public_path__ + "static/media/rank1.1f7c0a15.png";